import { io } from "socket.io-client";

const BASE_URL = (process.env.REACT_APP_BASE_URL || "http://localhost:8000/api").replace("/api", "");

let socket = null;

export function getSocket(userId) {
    if (!socket) {
        socket = io(BASE_URL, { autoConnect: false, transports: ["websocket", "polling"] });
    }
    if (!socket.connected && userId) {
        socket.connect();
        socket.emit("join", userId);
    }
    return socket;
}

export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}
